<template>
    <ui-card>
        <template #header>
            <div class="faq-header d-flex justify-content-between">
                <h4 class="mb-4">FAQ - najczęściej zadawane pytania</h4>
            </div>
        </template>

        <div
            v-for="(section, sectionIdx) in faqs"
            :key="sectionIdx"
            class="faq-section my-3"
            :class="{ 'first-section': sectionIdx === 0 }"
        >
            <h6 class="text-body mb-3 pl-2 faq-section__title">
                {{ section.title }}
            </h6>
            <faq-item
                v-for="(faq, faqIdx) in section.questions"
                :key="faqIdx"
                :index="faqIdx"
                :unique-index="getUniqueIndex({ faqIdx, sectionIdx })"
                v-bind="faq"
                @toggle="
                    onFaqItemToggle(getUniqueIndex({ faqIdx, sectionIdx }))
                "
                :active-faq-index="activeFaqIndex"
                :id="`faq-item-${getUniqueIndex({ faqIdx, sectionIdx })}`"
            />
        </div>
    </ui-card>
</template>

<script>
import { UiCard } from '../../global/ui'
import FaqItem from './FaqItem.vue'

export default {
    name: 'FaqSection',
    components: { UiCard, FaqItem },
    computed: {
        faqs() {
            return this.$store.getters.getFaqs
        }
    },
    data() {
        return {
            activeFaqIndex: -1,
            active: false
        }
    },
    methods: {
        getUniqueIndex({ faqIdx, sectionIdx }) {
            return (
                this.faqs
                    .filter((s, sIdx) => sIdx < sectionIdx)
                    .map(section => section.questions.length)
                    .reduce((prev, curr) => prev + curr, 0) + faqIdx
            )
        },
        onFaqItemToggle(uniqueFaxIdx) {
            const faqItem = document.getElementById(`faq-item-${uniqueFaxIdx}`)

            if (this.activeFaqIndex === uniqueFaxIdx) {
                this.activeFaqIndex = -1
                return
            }
            this.activeFaqIndex = uniqueFaxIdx

            this.$nextTick(() => {
                const faqItemTopViewport =
                    faqItem.getBoundingClientRect().top + window.scrollY
                if (faqItemTopViewport < window.scrollY + 200) {
                    this.$scrollTo(faqItem, 100, {
                        offset: -200
                    })
                }
            })
        }
    },
    beforeCreate() {
        this.$store.dispatch('snippetsLoad', {
            code: 'snippet007',
            moduleName: 'faq'
        })
    }
}
</script>

<style lang="scss" scoped>
.faq-header {
    .a-icon {
        min-width: 130px;
    }
}
.faq-section {
    &.first-section {
        margin-top: 0 !important;
    }
    &__title {
        font-weight: 400;
    }
}
</style>
